module.exports = __webpack_public_path__ + "img/blogs_green.57622653.png";